module.exports = __webpack_public_path__ + "bd.svg?a7978d3d0cb45d9a6dfae8569f7c9969";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bd.svg
// module id = 1246
// module chunks = 0